var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.types,"loading":_vm.loading,"mobile-breakpoint":NaN},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('type-row',{key:item.id,attrs:{"type":item},on:{"edit":_vm.onEdit}})]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }